module.exports = __webpack_public_path__ + "img/20.f63188ec.png";